export default "__VITE_ASSET__4226e1a0__"